import axios from "axios";

export default async function getConsumerCampaignV2Listing({
    id,
    length,
    start,
    column,
    order,
    search,
    date,
    type,
    products,
}) {
    return new Promise((resolve, reject) => {
        axios
            .post(`/campaignV2/customer/campaign/list`, {
                uuid: id,
                limit: length,
                skip: start,
                sortBy: column,
                orderBy: order,
                search,
                date,
                type,
                products
            })
            .then((response) => resolve(response.data))
            .catch((error) => {
                return reject(error.response.data);
            });
    });
}
